var _path, _mask, _g, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgDoc = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6663 5.30409L23.6557 10.6668H19.6183C19.093 10.6668 18.6663 10.1588 18.6663 9.53342V5.30409ZM26.321 9.77075L20.3943 3.10408C20.1423 2.82541 19.7837 2.66675 19.4077 2.66675H8.74101C6.86101 2.66675 5.33301 4.16275 5.33301 6.00008V26.0001C5.33301 27.8374 6.86101 29.3334 8.74101 29.3334H23.2583C25.1383 29.3334 26.6663 27.8374 26.6663 26.0001V10.6667C26.6663 10.3347 26.5437 10.0161 26.321 9.77075Z",
    fill: "#50BEE8"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 2,
    width: 22,
    height: 28
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6663 5.30409L23.6557 10.6668H19.6183C19.093 10.6668 18.6663 10.1588 18.6663 9.53342V5.30409ZM26.321 9.77075L20.3943 3.10408C20.1423 2.82541 19.7837 2.66675 19.4077 2.66675H8.74101C6.86101 2.66675 5.33301 4.16275 5.33301 6.00008V26.0001C5.33301 27.8374 6.86101 29.3334 8.74101 29.3334H23.2583C25.1383 29.3334 26.6663 27.8374 26.6663 26.0001V10.6667C26.6663 10.3347 26.5437 10.0161 26.321 9.77075Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.552 21.733C7.288 21.733 7 21.588 7 21.237V16.696C7 16.408 7.288 16.2 7.552 16.2H9.383C13.037 16.2 12.956 21.733 9.454 21.733H7.552ZM8.056 17.175V20.757H9.383C11.542 20.757 11.637 17.175 9.383 17.175H8.056Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.016 21.813C14.537 21.877 13.001 20.893 13.001 18.934C13.001 16.967 14.536 16 16.016 16C17.415 16.071 18.878 17.039 18.878 18.934C18.878 20.83 17.415 21.813 16.016 21.813ZM15.928 17.04C15.032 17.04 14.057 17.672 14.057 18.935C14.057 20.191 15.033 20.831 15.928 20.831C16.848 20.831 17.831 20.191 17.831 18.935C17.831 17.671 16.848 17.04 15.928 17.04Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8193 18.9259C19.8193 17.3829 20.7873 16.0559 22.6263 16.0559C23.3223 16.0559 23.8743 16.2639 24.4573 16.7679C24.6734 16.9669 24.6974 17.3189 24.4813 17.5429C24.2653 17.7339 23.9373 17.7109 23.7453 17.5189C23.4183 17.1749 23.0823 17.0799 22.6263 17.0799C21.3953 17.0799 20.8043 17.9519 20.8043 18.9269C20.8043 19.9189 21.3873 20.8299 22.6263 20.8299C23.0823 20.8299 23.5063 20.6449 23.8743 20.3179C24.1213 20.1259 24.4654 20.2209 24.6094 20.4139C24.7374 20.5899 24.8003 20.8859 24.5213 21.1649C23.9613 21.6859 23.2903 21.7899 22.6253 21.7899C20.6913 21.7899 19.8193 20.4689 19.8193 18.9259Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDoc, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/doc.cb3cfbda.svg";
export { ForwardRef as ReactComponent };